import {
  Box,
  Column,
  Columns,
  ContentBlock,
  Dropdown,
  Inline,
  Text,
} from 'braid-design-system';
import type { FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { links } from 'src/links';
import type { RouteProps } from 'src/types';
import { useIsMobileOrTablet } from 'src/utils/breakpoints';
import { useIsAuNz } from 'src/utils/hooks/useContext';
import { useQuery } from 'src/utils/hooks/useQuery';

import { Link } from '../Link/Link';

import * as styles from './Nav.css';

const navLinks: RouteProps[] = [
  links.CONNECT_WITH_SEEK,
  links.WHATS_POSSIBLE,
  links.CONNECTED_PARTERS,
  links.RELEASE_NOTES,
  links.LINK_YOUR_SOFTWARE,
];

interface NavProps {
  activeTab?: string;
}

export const Nav = ({ activeTab }: NavProps) => {
  const isAuNz = useIsAuNz();
  const isMobileOrTablet = useIsMobileOrTablet();
  const navigate = useNavigate();
  const version = useQuery().get('v');

  const mobileChange = (e: FormEvent<HTMLSelectElement>) => {
    const path = (e.target as HTMLSelectElement).value;
    // TODO track this link
    navigate({
      pathname: path,
      ...(version ? { search: `?v=${version}` } : {}),
    });
  };

  // Only show the submenu on AU and NZ
  if (!isAuNz) {
    return null;
  }

  if (isMobileOrTablet) {
    return (
      <Box paddingY="small" width="full">
        <Inline space="none" align="center">
          <Dropdown
            label=""
            id="sub-nav"
            onChange={mobileChange}
            value={`/${activeTab}`}
          >
            {navLinks.map((link, i) => (
              <option key={i} value={link.path}>
                {link.name}
              </option>
            ))}
          </Dropdown>
        </Inline>
      </Box>
    );
  }

  return (
    <Box background="surface">
      <Box component="nav" role="navigation" className={styles.nav}>
        <ContentBlock width="large">
          <Box paddingX="gutter">
            <Columns space="none" alignY="center">
              {navLinks.map((item: any, index) => {
                const isActive =
                  `/${activeTab}` === `/${item.activeTab}` ||
                  `/${activeTab}` === item.path;
                return (
                  <Column width="content" key={index}>
                    <Link href={item.path} tracking={item.tracking}>
                      <Text weight="regular" baseline={false}>
                        <Box
                          className={[
                            styles.navItem,
                            isActive && styles.isActive,
                          ]}
                        >
                          {item.name}
                        </Box>
                      </Text>
                    </Link>
                  </Column>
                );
              })}
            </Columns>
          </Box>
        </ContentBlock>
      </Box>
    </Box>
  );
};
